<template>
  <div class="media-upload-item">
    <div class="sample" v-if="notStarted"
      @click="toggleSelect"
      :style="{ backgroundImage: `url(${cover})` }"
      >
      <div class="tip">{{ tip }}</div>
    </div>
    <div
      class="preview"
      v-if="hasEnded"
      :style="{ backgroundImage: 'url(' + imagePreview + ')' }"
    ></div>
    <div class="progress-state" v-show="isUploading">
      <span>正在上传...</span>
    </div>
    <input @change="handleInputChange" type="file" ref="input" accept="image/*" :style="{ display: 'none' }">
    <img class="close-btn" v-show="hasEnded" src="../images/close.png" @click="deletePic" />
    <z-actionsheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { Actionsheet } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter';
import { apiNewRealAuthOCR } from '@api/resourceApi'
import { queryParams, getCookie } from '../../../../lib/utils'
import Compressor from 'compressorjs';

const query = queryParams()

//  文件上传状态
const fileUploadState = {
  NOT_STARTED: 0,
  UPLOADING: 1,
  ENDED: 2
}
let maxRequestID = 1

export default {
  name: 'SecurePicUploadItem',
  components: {
    'z-actionsheet': Actionsheet
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    },
    ocr: {
      type: Boolean,
      default: false
    },
    sdkOptions: {
      type: Object,
      default: () => {}
    },
    authType: {
      type: String,
      default: ''
    }
  },
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      imagePreview: '',
      uploadState: fileUploadState.NOT_STARTED,
      show: false,
      // 如果URL没有传sourcecode，根据不同APP设置默认值
      sourcecode: query.sourcecode || this.$route.query.sourcecode || (isSJJ ? 'c2p_selfmain_page' : 'card_selfmain_page'),
      actions: [
        { name: '开始拍照', value: 1 },
        { name: '从相册上传', value: 2 }
      ]
    }
  },
  computed: {
    notStarted() {
      return this.uploadState === fileUploadState.NOT_STARTED
    },
    isUploading() {
      return this.uploadState === fileUploadState.UPLOADING
    },
    hasEnded() {
      return this.uploadState === fileUploadState.ENDED
    },
    isFront() {
      if (this.type === 'front') {
        return '1'
      }
      return '0'
    }
  },
  methods: {
    uploadPic(params = {}) {
      if (this.uploadState === fileUploadState.UPLOADING) return

      const requestID = maxRequestID++

      this.imagePreview = ''
      this.uploadState = fileUploadState.NOT_STARTED

      const invokeIDCardCamera = native.wrap('takePhotoOfIDCard')

      invokeIDCardCamera(
        {
          requestid: requestID,
          compressQuality: native.in('zz') ? '0.5' : '0.9',
          compressWidth: native.in('zz') ? 800 : '',
          type: '2',
          isFront: this.isFront,
          ...this.sdkOptions,
          ...params
        },
        (res) => {
          if (!(res && res.code)) return

          if (res.code === '0') {
            if (Number(res.requestId) !== Number(requestID)) return

            if (this.uploadState !== fileUploadState.UPLOADING) {
              this.uploadState = fileUploadState.UPLOADING
            }

            if (res.photoBase64) {
              this.imagePreview = res.photoBase64
            }
            if (res.photoString) {
              console.info(res.photoString)
              if (this.ocr) {
                apiNewRealAuthOCR({
                  sourcecode: this.sourcecode,
                  type: this.authType,
                  picKeyFro: this.isFront == '1' ? res.photoString : '',
                  picKeyBack: this.isFront == '0' ? res.photoString : ''
                }).then(ocrres => {
                  this.uploadState = fileUploadState.ENDED
                  this.$emit('uploaded', res.photoString, ocrres)
                }).catch(err => {
                  this.uploadState = fileUploadState.ENDED
                  this.$emit('uploaded', res.photoString)
                  console.log(err)
                })
              } else {
                this.uploadState = fileUploadState.ENDED
                this.$emit('uploaded', res.photoString)
              }
            }
          } else {
            this.imagePreview = ''
            this.uploadState = fileUploadState.NOT_STARTED
            console.warn(res.msg || '调起拍照失败')
            this.$toast(res.msg || '调起拍照失败')
          }
        }
      )
    },
    deletePic() {
      this.$refs.input.value = ''
      this.imagePreview = ''
      this.uploadState = fileUploadState.NOT_STARTED
      this.$emit('uploaded', '')
    },
    toggleSelect() {
      if (native.in('zz') || getCookie('t') === '243' || getCookie('t') === '244') {
        this.show = !this.show
      } else {
        this.$refs.input.click()
      }
    },
    onSelect(val) {
      this.show = !this.show
      if (val.value == 2) {
        this.uploadPic({ chooseAlbum: 1 })
      } else {
        this.uploadPic()
      }
    },
    async uploadzzos(file) {
      const data = new FormData()
      data.append('uploadfiles', file, '.jpeg')
      const res = await fetch('https://dsyy.zhuanzhuan.com/uploadFileZZos', {
        method: 'POST',
        credentials: 'include',
        body: data
      }).then(response => {
        return response.json()
      })
        .catch(err => {
          console.warn(err)
          this.$toast('上传失败')
        })
      return res ? res.respData : undefined
    },
    fileToDataUrl(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      return new Promise((resolve) => {
        reader.onload = function() {
          resolve(this.result)
        }
      })
    },
    async handleInputChange(e) {
      let file = e.target.files[0]
      if (!file) return
      this.uploadState = fileUploadState.UPLOADING
      file = await new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.6,
          success(result) {
            resolve(result)
          },
          error(err) {
            console.log(err.message);
            resolve(file)
          }
        });
      })

      const base64 = await this.fileToDataUrl(file)
      const res = await this.uploadzzos(file)
      if (res == undefined) {
        this.uploadState = fileUploadState.NOT_STARTED
      } else {
        if (this.ocr) {
          apiNewRealAuthOCR({
            sourcecode: this.sourcecode,
            type: this.authType,
            picKeyFro: this.isFront == '1' ? res.fileId : '',
            picKeyBack: this.isFront == '0' ? res.fileId : ''
          }).then(ocrres => {
            this.$emit('uploaded', res.fileId, ocrres)
            this.imagePreview = base64
            this.uploadState = fileUploadState.ENDED
          }).catch(err => {
            this.$emit('uploaded', res.fileId)
            this.imagePreview = base64
            this.uploadState = fileUploadState.ENDED
            console.log(err)
          })
        } else {
          this.$emit('uploaded', res.fileId)
          this.imagePreview = base64
          this.uploadState = fileUploadState.ENDED
        }
      }
    }
  },
  watch: {
    authType: function(_newval, _oldval) {
      this.deletePic()
    }
  }
}
</script>

<style scoped lang="less">
  @import 'MediaUploadItem.less';
</style>
